//==============================
// Newsletter Overlay
//==============================

var newsletterOverlay = $('.newsletter-overlay');

function showNewsletter(delay) {
  if(newsletterOverlay.is(':visible')) {
    if (Cookies.get("newsletter") == "SET") {} else {
      setTimeout(function() {
        newsletterOverlay.removeClass('hidden');
      }, delay);
      setTimeout(function() {
        newsletterOverlay.focus();
      }, delay + 100);
    }
  }
}

function hideNewsletter() {
  Cookies.set("newsletter", "SET", { expires: 7 });
  newsletterOverlay.addClass('hidden');
  setTimeout(function() {
    $('.header').focus();
  }, 1);
}

$(window).on('load', function() {
    if(body.hasClass('home')) {
      showNewsletter(2000);
    } else {
      showNewsletter(0);
    }
});

$('.js-newsletter-overlay-close').click(function() {
  hideNewsletter();
  return false;
});

newsletterOverlay.click(function() {
  hideNewsletter();
});

newsletterOverlay.find('.button').click(function() {
  hideNewsletter();
});

$('.newsletter-overlay-inner').click(function(e) {
  e.stopPropagation();
});
